import React from "react";
import { useState } from "react";
import PlaceIcon from '@mui/icons-material/Place';

//MUI IMPORTS
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  Container,
  Grid,
  CardActionArea,
} from "@mui/material";

//MUI ICONS
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Receipt as ReceiptIcon,
  Business as BusinessIcon,
  Inventory as InventoryIcon,
  FormatListBulleted as FormatListBulletedIcon,
  Save as SaveIcon,
  RemoveRedEye as RemoveRedEyeIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Visibility as VisibilityIcon,
  Person as PersonIcon,
  BusinessCenter as BusinessCenterIcon,
  Payment as PaymentIcon,
  PropaneTank as PropaneTankIcon,
  AttachMoney as AttachMoneyIcon,
  AddCircleOutline as AddCircleOutlineIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { keyframes } from "@mui/system";

//CUSTOM IMPORTS
import DialogBusquedaClientes from "./dialogs/DialogBusquedaClientes";
import DataFactura from "./components/DataFactura";

function FormDatosFact({
  formData,
  setFormData,
  dataCliente,
  setDataCliente,
  setDataDireccion,
  dataDireccion,
  permisos,
  props,
  setItems,
  sucursales,
  // remitos,
  tipoComprobante,
  empresas,
  showCheckConsFinal,
  setShowCheckConsFinal,
  getSucEmpresa,
  paramsNegocios,
  // sucTieneAlias,
  comprobanteAsociado,
  setComprobanteAsociado,

  anulacionCompleta,
  anulacionParcial,
  setAnulacionParcial,
  setAnulacionCompleta,
  limpiarItems,

  tipoCbtePosible,
  setTipoCbtePosible,
  userSucData
  // localStorageData
}) {
  /* ----------------------------ESTADOS Y REFS-------------------------------  */
  const bgColor = "#fff";
  const [openDialogClientes, setOpenDialogClientes] = useState(false);

  /* --------------------------- RENDER --------------------------------  */

  const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
`;

  const glow = keyframes`
  0%, 100% {
    box-shadow: 0 0 5px rgba(25, 118, 210, 0.4);
  }
  50% {
    box-shadow: 0 0 20px rgba(25, 118, 210, 0.8);
  }
`;

  return (
    <div>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          spacing={1}
          mb={1}
        >
          <Grid item xs={12} md={12} lg={3}>
            <Card
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            ><Box
              sx={{
                backgroundColor: "primary.main",
                color: "white",
                p: 1.5,
                display: "flex",
                justifyContent: "space-between", // Separa ambos extremos
                alignItems: "center",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <PersonIcon />
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 500, fontSize: 15 }}
                  >
                    Datos del cliente
                  </Typography>
                </Box>

                {!!dataCliente && (
                  <Chip
                    label={`CUIT: ${dataCliente?.cuit?.length && dataCliente?.cuit?.length > 1
                      ? dataCliente?.cuit
                      : "No informa."
                      }`}

                    variant="outlined"
                    size="small"
                    sx={{
                      backgroundColor:
                        dataCliente?.cuit?.length && dataCliente?.cuit?.length > 1
                          ? "#efeff0"
                          : "#e64100",
                      color: "#fff",
                      fontSize: "0.75rem",
                      fontWeight: 700,
                      borderColor:
                        dataCliente?.cuit?.length && dataCliente?.cuit?.length > 1
                          ? "#efeff0"
                          : "#e64100",
                    }}
                  />

                )}
              </Box>
              <CardActionArea
                sx={{
                  flex: 1,
                }}
                disabled={!!props}
                onClick={() => setOpenDialogClientes(true)}
              >
                {dataCliente ? (
                  <CardContent sx={{ px: 2, pt: 1, pb: "16px !important" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            flexWrap: "wrap",
                          }}
                        >
                          <Typography variant="body2" fontWeight="medium">
                            {dataCliente?.razon_social}
                          </Typography>
                          
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            mt: 0.5,
                          }}
                        >
                          <BusinessIcon sx={{ fontSize: 12 }} color="primary" />
                          <Typography variant="caption" color="text.secondary">
                            <b>
                              {dataCliente?.empresa}{" "}
                              {dataCliente.sucursal
                                ? `(${dataCliente.sucursal})`
                                : ""}
                            </b>
                          </Typography>
                        </Box>

                        <Box sx={{ mt: 0.5 }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            <BusinessCenterIcon
                              sx={{ fontSize: 12 }}
                              color="primary"
                            />
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              <b>{dataCliente?.nombre_situacioniva || "-"}</b>
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            <PaymentIcon
                              sx={{ fontSize: 12 }}
                              color="primary"
                            />
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              <b>{dataCliente?.condicion || "-"}</b>
                            </Typography>
                          </Box>
                          {dataDireccion && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "top",
                                gap: 0.5,
                              }}
                            >
                              <PlaceIcon
                                sx={{ fontSize: 12 }}
                                color="error"
                              />
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                <b>Entrega En:</b> {dataDireccion?.direccion_entrega || "-"} ({dataDireccion.nombre_direccion}) || {dataDireccion.sucursal}
                              </Typography>
                            </Box>
                          )}

                          {/* {Boolean(dataCliente?.segmento) && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <AssignmentIcon
                                sx={{ fontSize: 12, color: "primary" }}
                              />
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                <b>Segmento</b>: {dataCliente?.segmento}
                              </Typography>
                            </Box>
                          )} */}

                          {/* {!!dataCliente?.descr_unidad_fact && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <PropaneTankIcon
                                sx={{ fontSize: 12 }}
                                color="primary"
                              />
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                fontWeight={600}
                              >
                                Unidad Facturación:{" "}
                                {dataCliente?.descr_unidad_fact?.toUpperCase() ||
                                  "-"}
                              </Typography>
                            </Box>
                          )} */}

                          {/* {Boolean(dataCliente?.precio_especial) && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                mt: 0.5,
                              }}
                            >
                              <AttachMoneyIcon
                                sx={{ fontSize: 16, color: "orange" }}
                              />
                              <Typography
                                variant="caption"
                                fontSize={12}
                                fontWeight="bold"
                                color="warning.main"
                              >
                                PRECIO ESPECIAL
                              </Typography>
                            </Box>
                          )} */}
                        </Box>
                      </Box>
                      {tipoCbtePosible?.letra && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 42,
                            height: 42,
                            borderRadius: "8px",
                            backgroundColor: "primary.main",
                            color: "primary.contrastText",
                            boxShadow: 2,
                            flexShrink: 0,
                          }}
                        >
                          <Typography
                            variant="h4"
                            component="span"
                            sx={{
                              fontWeight: "bold",
                              lineHeight: 1,
                            }}
                          >
                            {tipoCbtePosible.letra}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </CardContent>
                ) : (
                  <Card
                    sx={{
                      animation: `${glow} 2s ease-in-out infinite`,
                      backgroundColor: "rgba(25, 118, 210, 0.05)",
                    }}
                  >
                    <CardContent
                      sx={{
                        flex: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <SearchIcon
                          sx={{
                            fontSize: 40,
                            color: "primary.main",
                            animation: `${pulse} 1.5s ease-in-out infinite`,
                          }}
                        />
                        <Typography
                          variant="subtitle1"
                          sx={{
                            color: "primary.main",
                            fontWeight: 600,
                            textAlign: "center",
                          }}
                        >
                          👆 Seleccionar Cliente
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "text.secondary",
                            fontStyle: "italic",
                          }}
                        >
                          (Requerido para continuar)
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                )}
              </CardActionArea>
            </Card>
          </Grid>
          <Grid item xs={12} md={12} lg={9}>
            <Card
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <DataFactura
                dataCliente={dataCliente}
                formData={formData}
                setFormData={setFormData}
                comprobanteAsociado={comprobanteAsociado}
                setComprobanteAsociado={setComprobanteAsociado}
                showCheckConsFinal={showCheckConsFinal}
                setShowCheckConsFinal={setShowCheckConsFinal}
                anulacionCompleta={anulacionCompleta}
                setAnulacionCompleta={setAnulacionCompleta}
                permisos={permisos}
                sucursales={sucursales}
                // sucTieneAlias={sucTieneAlias}
                paramsNegocios={paramsNegocios}
                bgColor={bgColor}
                setDataCliente={setDataCliente}
                setDataDireccion={setDataDireccion}
                setItems={setItems}
                tipoComprobante={tipoComprobante}
                empresas={empresas}
                getSucEmpresa={getSucEmpresa}
                limpiarItems={limpiarItems}
                anulacionParcial={anulacionParcial}
                setAnulacionParcial={setAnulacionParcial}
                setTipoCbtePosible={setTipoCbtePosible}
                userSucData={userSucData}
              />
            </Card>
            {openDialogClientes && (
              <DialogBusquedaClientes
                open={openDialogClientes}
                setOpen={setOpenDialogClientes}
                dataCliente={dataCliente}
                setDataCliente={setDataCliente}
                setFormData={setFormData}
                formData={formData}
                setItems={setItems}
                setDataDireccion={setDataDireccion}
                paramsNegocios={paramsNegocios}
                setTipoCbtePosible={setTipoCbtePosible}
                userSucData={userSucData}
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default FormDatosFact;
